<template>
  <div>
    <div class="container">
      <el-table
        :data="data.records"
        border
        class="table"
        ref="multipleTable"
        header-cell-class-name="table-header"
      >
        <el-table-column prop="name" label="用户名称"></el-table-column>
        <el-table-column
          align="center"
          prop="legalPerson"
          label="法定代表人"
        ></el-table-column>
        <el-table-column
          prop="username"
          label="注册账号"
          align="center"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="unifiedSocialCreditCode"
          label="统一社会信用代码"
        ></el-table-column>
        <el-table-column label="申请时间" align="center">
          <template #default="scope"
            >{{ $utils.formatDate(scope.row.applyTime, "yyyy-MM-dd hh:mm:ss") }}
          </template>
        </el-table-column>
        <el-table-column label="状态" align="center">
          <template #default="">
            <el-link :underline="false" type="danger">待审核</el-link>
          </template>
        </el-table-column>
        <el-table-column label="提供资料" width="180" align="center">
          <template #default="scope">
            <el-button
              type="text"
              icon="el-icon-edit"
              @click="handleEdit(scope.row)"
              >详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          background
          layout="total, prev, pager, next"
          :current-page="data.current"
          :page-size="20"
          :total="data.total"
          @current-change="getData"
        ></el-pagination>
      </div>
    </div>

    <!-- 编辑弹出框 -->
    <el-dialog title="详情" v-model="editVisible" width="30%">
      <div class="editVisible-dialog">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-image
              :src="$utils.fileUrl(itemData.logo)"
              :preview-src-list="[$utils.fileUrl(itemData.logo)]"
            >
            </el-image>
            <!-- <img :src="$utils.fileUrl(itemData.logo)" alt="" /> -->
          </el-col>
          <el-col :span="8">
            <el-image
              :src="$utils.fileUrl(itemData.businessLicense)"
              :preview-src-list="[$utils.fileUrl(itemData.businessLicense)]"
            >
            </el-image>
            <!-- <img :src="$utils.fileUrl(itemData.businessLicense)" alt="" /> -->
          </el-col>
          <el-col :span="8">
            <el-image
              :src="$utils.fileUrl(itemData.powerOfAttorney)"
              :preview-src-list="[$utils.fileUrl(itemData.powerOfAttorney)]"
            >
            </el-image>
            <!-- <img :src="$utils.fileUrl(itemData.powerOfAttorney)" alt="" /> -->
          </el-col>
        </el-row>
        <table>
          <tr>
            <td>名称:</td>
            <td>{{ itemData.name }}</td>
          </tr>
          <tr>
            <td>注册账号：</td>
            <td>{{itemData.username}}</td>
          </tr>
          <tr>
            <td>申请时间：</td>
            <td>{{$utils.formatDate(itemData.applyTime, "yyyy-MM-dd")}}  </td>
          </tr>
          <tr>
            <td>法定代表人:</td>
            <td>{{ itemData.legalPerson }}</td>
          </tr>
          <tr>
            <td>统一社会信用代码：</td>
            <td>{{ itemData.unifiedSocialCreditCode }}</td>
          </tr>
          <tr>
            <td>证件类型：</td>
            <td>{{ idType(itemData.idType) }}</td>
          </tr>
          <tr>
            <td>证件号：</td>
            <td>{{ itemData.idCard }}</td>
          </tr>
          <tr>
            <td>保荐码：</td>
            <td>
              {{ itemData.referralCode }}
            </td>
          </tr>
          <tr>
            <td>保荐人：</td>
            <td>{{ itemData.inviter }}</td>
          </tr>
          
        </table>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="adopt">通过</el-button>
          <el-button
            type="danger"
            @click="
              editVisible = false;
              reject_dialog = true;
            "
            >驳回</el-button
          >
        </span>
      </template>
    </el-dialog>
    <!-- 编辑弹出框 -->
    <el-dialog title="驳回原因" v-model="reject_dialog" width="30%">
      <div class="editVisible-dialog">
        <el-input
          rows="5"
          resize="none"
          maxlength="20"
          type="textarea"
          show-word-limit
          v-model="auditRemark"
        >
        </el-input>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="reject">确认驳回</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {},
      itemData: {},
      editVisible: false,
      loading: false,
      reject_dialog: false,
      auditRemark: "",
    };
  },
  methods: {
    async getData(page) {
      const params = {
        currentPage: page,
        pageSize: 20,
      };
      this.$loading.start();
      const res = await this.$api.authe.getGroupAutheList(params);
      this.$loading.done();
      if (res.code === 10200) {
        this.data = res.data;
      } else {
        this.$message.error(res.msg);
      }
    },
    handleEdit(data) {
      this.itemData = data;
      this.editVisible = true;
    },
    idType(type) {
      switch (type) {
        case 1:
          return "身份证";
        case 2:
          return "护照";
        case 3:
          return "其他";
      }
    },
    // 提交审核
    async companyAudit(params) {
      if (!this.loading) {
        this.loading = true;
        this.$loading.start();
        const res = await this.$api.authe.groupAudit(params);
        this.loading = false;
        this.$loading.done();
        if (res.code === 10200) {
          this.getData(this.data.current);
          this.editVisible = false;
          this.reject_dialog = false;
          this.auditRemark = ''
          if (params.status === 1) {
            this.$message.success("审核通过已通知该用户！");
          } else {
            this.$message.success("驳回成功！");
          }
        } else {
          this.$message.error(res.msg);
        }
      }
    },
    // 通过
    adopt() {
      const params = {
        id: this.itemData.id,
        status: 1,
        auditRemark: "",
      };
      this.companyAudit(params);
    },

    // 驳回
    reject() {
      if (!this.auditRemark) {
        this.$message.warning("请输入驳回原因");
        return;
      }
      const params = {
        id: this.itemData.id,
        status: 2,
        auditRemark: this.auditRemark,
      };
      this.companyAudit(params);
    },
  },
  mounted() {
    this.getData();
  },
  
};
</script>

<style lang="scss" scoped>
.editVisible-dialog {
  .el-image {
    width: 120px;
  }
  table {
    width: 100%;
    border-collapse: collapse;
    tr {
      padding: 0;
      &:first-child {
        td {
          border-top: 1px solid #ebeef5;
        }
      }
      td {
        padding: 10px;
        border-right: 1px solid #ebeef5;
        border-bottom: 1px solid #ebeef5;
        &:first-child {
          width: 130px;
          border-left: 1px solid #ebeef5;
        }
      }
    }
  }
}
</style>